import React from "react";
import {
  Route,
  Switch,
  Redirect,
  // useHistory,
} from "react-router-dom";

import PortalLayout from "layouts/Portal.js";
import { useAuth0 } from "@auth0/auth0-react";

import Loading from "./components/loading.js";

import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";

const App = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Switch>
      <Route path="/portal" component={PortalLayout} />

      <Redirect from="/" to="/portal/highlights" />
    </Switch>
  );
};

export default App;

